import { AxiosResponse } from 'axios';
import api from '../api';
import { ChangePasswordRequest, ChangePasswordResponse } from '../../interface/changePasswordModel';
import { IUserSecuritySettings } from '../../interface/profile.interface';

const changePassword = async (
  data: ChangePasswordRequest,
): Promise<AxiosResponse<ChangePasswordResponse>> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const res: AxiosResponse<ChangePasswordResponse> = await api.put('/user/changePassword', data);
    return res;
  } catch (error: any) {
    // Throw the original error object so frontend can access error.response.data.message
    throw error;
  }
};

/**
 * CVA-3753: read the signed-in user's two-factor posture.
 *
 * Returned inside the standard envelope, so callers read `res.data.data`.
 */
const getMySecuritySettings = async (): Promise<AxiosResponse<{ data: IUserSecuritySettings }>> => {
  return api.get('/user/security');
};

/**
 * CVA-3753: flip the signed-in user's two-factor preference.
 *
 * Rejects with `errorCode: 'TWO_FA_EMAIL_NOT_VERIFIED'` when enabling on an
 * account that has no verified, deliverable email. Remember the axios response
 * interceptor rejects with the response *body*, so read `err.errorCode`, never
 * `err.response`.
 */
const updateMyTwoFactor = async (
  enabled: boolean,
): Promise<AxiosResponse<{ data: { twoFaEnabled: boolean } }>> => {
  return api.patch('/user/security/two-factor', { enabled });
};

/**
 * Persist the user's selected UI language to the backend so that
 * backend-generated emails and PDFs render in the same language.
 * Best-effort: callers should not block the UI on this.
 */
const setPreferredLanguage = async (language: string): Promise<void> => {
  await api.patch('/user/language', { language });
};

export const userService = {
  changePassword,
  getMySecuritySettings,
  updateMyTwoFactor,
  setPreferredLanguage,
};
